module.exports = __webpack_public_path__ + "img/ico_3.6e12f4f1.png";